import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';

import { Button, FormControl } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from '../ViewMessage.css';
import bt from '../../../components/commonStyle.css';

// Helpers
import submit from './submit';
import validate from './validate';

//Locale
import messages from '../../../locale/messages';

// Images
import sendIcon from '/public/viewMessage/sendIcon.svg';

const renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className, placeholder }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <FormControl
        {...input}
        className={className}
        componentClass="textarea"
        placeholder={placeholder}
      >
        {children}
      </FormControl>
      {touched && error && <span className={cx(s.errorMessage, 'errorMessageFieldRTL')}>{formatMessage(error)}</span>}
    </div>
  );
}
const SendMessage = ({ error, handleSubmit, submitting }) => {

  const { formatMessage } = useIntl();

  return (
    <div className={cx(s.messageBoxSection)}>
      <div className={cx(s.radiusColor, 'sendMessageRadius', s.topRadiusColor, 'topRadiusColorRTL', 'sendMessageRadiusRTL')}>
        <form onSubmit={handleSubmit(submit)}>
          <div className={s.displayFlex}>
            <div className={cx(s.messageBoxStyle, s.topMessageBar, 'topMessageBarRTL', s.panelBubble, s.panelBubbleRight, "messageTextArea", 'ViewBubbleRight')}>
              <Field
                name="content"
                className={cx(s.textAreaBox, 'textAreaBoxRTL')}
                component={renderFormControlTextArea}
                placeholder={formatMessage(messages.writeMessage)}
              />
            </div>
            <div className={cx('textAlignLeftRtl', s.messageSendBtnSec, 'messageSendBtnSecRTL')}>
              <Button className={cx(s.messageSendIcon, 'messageSendIconRTL')} type="submit" disabled={submitting || error}>
                <img src={sendIcon} alt='' className={s.msgSendIcon} />
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

SendMessage.propTypes = {
  threadId: PropTypes.number.isRequired,
  formatMessage: PropTypes.any,
};

export default reduxForm({
  form: 'SendMessage',
  validate
})(withStyles(s, bt)(SendMessage));